import { render, staticRenderFns } from "./form-button.vue?vue&type=template&id=87d60d5e&"
import script from "./form-button.vue?vue&type=script&lang=js&"
export * from "./form-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports